import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import config from "../../../config.json";

import successImage from "../../../assets/img/success.png";
import errorImage from "../../../assets/img/error-image.png";
import queryString from "query-string";
import API from "../../../api/baseUrl";
import { serialize, original } from "../../../functions/helper";
import { useCookies } from "react-cookie";

import "./styles.scss";
import Loading from "../../../components/loading";
import swal from "sweetalert";

export default function ResultPay() {
  const Login_User_Token = localStorage.getItem("user_login_token");
  const Login_User_cp = localStorage.getItem("user_login_cp");
  const [cookei, setCookei] = useCookies(["token", "cp"]);

  const history = useHistory();

  const { search } = useLocation();
  const query = queryString.parse(search);

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("fail");
  const [detail, setDetail] = useState({});

  useEffect(() => {

    if (!query.Authority) history.push("/");
    if ((Login_User_Token && Login_User_cp) || (cookei.token && cookei.cp)) {
    } else {
      swal("", `لطفا ابتدا وارد سامانه شوید`, "error", {
        button: "متوجه شدم",
      }).then((value) => {
        if (value) {
          history.push("/");
        } else history.push("/");
      });
      return;
    }
    checkVerify();
  }, []);

  const checkVerify = async () => {
    try {
      const resService2 = await API.post(
        serialize({
          id: 1742,
          sp_param: `'${Login_User_cp || cookei.cp}','${
            Login_User_cp || cookei.cp
          }','3','101','machine_nm','machine_ip','0','0','0','${
            query?.Authority
          }','222'`,
          Login_User_Token: Login_User_Token || cookei.token,
          Login_User_cp: Login_User_cp || cookei.cp,
        }),
      );
      console.log(original(resService2.data, false)[0]);
      if (parseInt(original(resService2.data, false)[0]?.s_result) > 0) {
        setStatus("success");
        fetchVisit();
      } else {
        setLoading(false);
        setStatus("fail");
      }
      setDetail(original(resService2.data, false));
    } catch (error) {
      setStatus("error");
      setLoading(false);
      console.log(error);
    }
  };

  const fetchVisit = async () => {
    try {
      const resService2 = await API.post(
        serialize({
          id: 1761,
          sp_param: `'${Login_User_Token || cookei.token}','${
            Login_User_cp || cookei.cp
          }','3','101','machine_nm','machine_ip','0','0','0','${
            query?.Authority
          }','0','','','','','','','',''`,
          Login_User_Token: Login_User_Token || cookei.token,
          Login_User_cp: Login_User_cp || cookei.cp,
        }),
      );
      setDetail(original(resService2.data, false)[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleRedirect = () => {
    history.push({
      pathname: "/",
    });
  };

  return (
    <div
      className="fast-visit-page"
      style={{
        background: `linear-gradient(45deg,${
          config.auth_back_color_1
            ? config.auth_back_color_1
            : "rgba(86, 0, 110, 1)"
        } 10%,${
          config.auth_back_color_2
            ? config.auth_back_color_2
            : "rgba(33, 150, 243, 1)"
        } 100%)`,
      }}>
      {!loading ? (
        <div className="fast-visit-page__box">
          {status === "success" ? (
            <div className="result-pay">
              <img src={successImage} width="150px" />
              <h3 className="result-pay__title">پرداخت موفق</h3>
              <p>{detail.s_message}</p>
            </div>
          ) : status === "fail" ? (
            <div className="result-pay">
              <img src={errorImage} width="150px" />
              <h3 className="result-pay__title">پرداخت ناموفق</h3>
              <p>{detail.s_message}</p>
            </div>
          ) : status === "error" ? (
            <div className="result-pay">
              <img src={errorImage} width="150px" />
              <h3 className="result-pay__title">خطایی رخ داد</h3>
              <p>عملیات با خطا مواجه شد لطفا مجددا تلاش کنید</p>
            </div>
          ) : (
            <></>
          )}
          <button
            className="button"
            style={{ width: "250px" }}
            onClick={handleRedirect}>
            بازگشت به صفحه اصلی
          </button>
        </div>
      ) : (
        <></>
      )}
      {loading && <Loading />}
    </div>
  );
}
